import { getUser } from "../api/users.js";
import { SwApiStore } from "./sw-api-store.js";

export const userStore = SwApiStore({
  get: () => getUser(),
  init: () => JSON.parse(localStorage.getItem("user") || "{}"),
});
